<section class="container">
    <div class="card-container">
        <div class="card-image-expanded"></div>

        <div class="card-body">
            <div class="card-content">
                <span class="card-title">{{'my-ford-experience.card.title' | translate}}</span>
                <span class="card-subtitle">{{'my-ford-experience.card.description' | translate}}</span>
            </div>
            <div class="card-image"></div>
            <lib-button [type]="'secondary-large'"  class="card-button" [id]="'cardButton'" [disabled]="false" (clickButton)="redirect()">
                <span class="button-title">{{'my-ford-experience.card.button-cta' | translate}}</span>
                <div class="button-icon"></div>
            </lib-button>
        </div>
    </div>
</section>